import { Component } from '@angular/core';

@Component({
  selector: 'app-product-detail-distribution-webshop',
  imports: [],
  templateUrl: './product-detail-distribution-webshop.html'
})
export class ProductDetailDistributionWebshop {

}
